import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M3 9l4.5 1l3 2.5","key":"svg-1"}],["path",{"d":"M13 21v-8l3 -5.5","key":"svg-2"}],["path",{"d":"M8 4.5l4 2l4 1l4 3.5l-2 3.5","key":"svg-3"}]]

const IconKarate = createReactComponent('outline', 'karate', 'Karate', __iconNode);

export default IconKarate;